/* Pure Limitless v3.1: Klaviyo Reviews enhancer (spec 34). Home page and the
   NAD30 product page, deferred, no dependencies. Pairs with
   assets/nad-v3-kl-reviews.css.
   1. Motion gate: html.v3-klr-anim is set only when the page's own
      before-paint flag html.lf-anim is present (it is never set under
      prefers-reduced-motion) and IntersectionObserver exists. Without it every
      star, number, bar and card renders in its final state.
   2. Star badges that could not be filled on the server (no reviews
      metafield) read Klaviyo's hidden star widget: its link carries
      aria-label "4.8 stars, 46 reviews". Nothing is shown until that real
      value exists; a zero count or a missing widget leaves the badge hidden.
   3. The full widget: marks the wrapper hydrated (hides the fallback line),
      re-shapes Klaviyo's star SVGs to the site star (the fill fraction is read
      from Klaviyo's own gradient stop "fill-stop-1-*"), and hands the summary
      and each review card to the reveal observer, including cards added later
      by "Show more", sorting and filtering.
   Each element animates once per page view. */
(() => {
  const d = document, h = d.documentElement,
    A = h.classList.contains('lf-anim') && !matchMedia('(prefers-reduced-motion:reduce)').matches,
    $ = (s, r) => [...(r || d).querySelectorAll(s)],
    io = A && new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -10%' }),
    see = (x) => io && io.observe(x),
    watch = (el, f) => {
      let q = 0;
      new MutationObserver(() => { q = q || requestAnimationFrame(() => { q = 0; f(); }); }).observe(el, { childList: true, subtree: true });
      f();
    },
    fill = (b, r, n) => {
      if (!(r > 0 && n > 0)) return;
      const v = r.toFixed(1), t = n + ' review' + (n > 1 ? 's' : '');
      $('.v3-klr__star', b).forEach((s, i) => s.style.setProperty('--f', Math.max(0, Math.min(1, r - i))));
      $('[data-klr-v]', b).forEach((x) => { x.textContent = { avg: v, count: t, sr: 'Rated ' + v + ' out of 5 from ' + t }[x.dataset.klrV]; });
      b.hidden = false;
      see(b);
    };
  if (A) h.classList.add('v3-klr-anim');
  $('[data-klr-anim]:not([hidden])').forEach(see);

  $('[data-klr-src]').forEach((s) => {
    watch(s, () => {
      const a = s.querySelector('[aria-label]'),
        m = a && a.getAttribute('aria-label').match(/(\d+(?:[.,]\d+)?)\D+?([\d,.]+)/);
      if (m) fill(s.closest('[data-klr-stars]'), +m[1].replace(',', '.'), +m[2].replace(/\D/g, ''));
    });
  });

  $('[data-klr-mount]').forEach((m) => {
    const k = m.closest('.v3-klr');
    watch(m, () => {
      if (m.firstElementChild) k.classList.add('is-hydrated');
      $('.kl_reviews__stars_badge svg:not(.klr-s)', m).forEach((g) => {
        const o = g.querySelector('[id^="fill-stop-1"]');
        if (o) { g.style.setProperty('--f', parseFloat(o.getAttribute('offset')) / 100); g.classList.add('klr-s'); }
      });
      $('.kl_reviews__summary,.kl_reviews__review_item', m).forEach(see);
    });
  });
})();
